import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-update-service-active',
    standalone: true,
    imports: [TranslateModule],
    template: `
        @if (active) {
            <a class="u-link" (click)="update.emit(false)">{{ 'SERVICE_ACTIVE.FALSE' | translate }}</a>
        } @else {
            <a class="u-link" (click)="update.emit(true)">{{ 'SERVICE_ACTIVE.TRUE' | translate }}</a>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateServiceActiveComponent {
    @Input() public active: boolean;
    @Output() public update: EventEmitter<boolean> = new EventEmitter();
}
